import {
  CollectionEntriesDocument,
  DeleteCollectionEntryMutation,
  useDeleteCollectionEntryMutation,
  withStandardDeleteHook,
} from '@spotify/confidence-graphql';

export const useDeleteCollectionEntry = withStandardDeleteHook<
  DeleteCollectionEntryMutation,
  'deleteCollectionEntry'
>(useDeleteCollectionEntryMutation, 'deleteCollectionEntry', {
  refetchQueries: [CollectionEntriesDocument],
  awaitRefetchQueries: true,
});
